/**
 * The separation between main.ts and bootstrap.ts is required to create a
 * an asynchronous boundary in the modules and allow eager Federated Modules
 * See reference: https://webpack.js.org/concepts/module-federation/#uncaught-error-shared-module-is-not-available-for-eager-consumption
 */

import('./bootstrap')
	.catch(error => {
		console.group('Federated Module bootstrap issues!!!');
		console.warn('There is an error during the Federated Module bootstrap');

		console.error(error);

		console.groupEnd();
	});
